import { Component, Inject, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { CollaborationOperationsService } from '../../../../services/common/collaboration-operations.service';
import { OpenEstimateOperationsService } from '../../../../services/common/open-estimate-operations.service';
import { EstimateCloseService } from '../../../../services/estimate-close.service';
import { CONSTANTS } from '../../../../Constants/Constants';

@Component({
  selector: 'app-discard-collab-dialog',
  imports: [MatDialogModule,
            MatButtonModule,
            TranslatePipe],
  templateUrl: './discard-collab-dialog.component.html',
  styleUrl: './discard-collab-dialog.component.scss'
})
export class DiscardCollabDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DiscardCollabDialogComponent>,
    private readonly collaborationOperationsService: CollaborationOperationsService,
    private readonly openEstimateOperationsService: OpenEstimateOperationsService,
    private readonly closeEstimateOperationsService: EstimateCloseService,
    @Optional() @Inject(MAT_DIALOG_DATA) private readonly data: { isEstimateClosing?: boolean } | null
  ) { }

  async discard(): Promise<void> {
    if (this.data?.isEstimateClosing) {
      // Caller closes the estimate, so skip reopening it here.
      const closingResponse = await this.collaborationOperationsService.performDiscard(true);
      this.dialogRef.close(closingResponse ? CONSTANTS.DISCARDED : CONSTANTS.DISCARD_FAILED);
      return;
    }

    const response = await this.collaborationOperationsService.performDiscard();
    if (response) {
      await this.closeEstimateOperationsService.closeEstimate();
      await this.openEstimateOperationsService.openEstimate(response);
      this.dialogRef.close(CONSTANTS.DISCARDED);
    } else {
      this.dialogRef.close(CONSTANTS.DISCARD_FAILED);
    }
  }
}
